export default class Animation {
  constructor (renderFrame) {
    this.renderFrame = renderFrame
    this.nextFrame = null
  }

  start () {
    const animate = () => {
      this.nextFrame = window.requestAnimationFrame(() => {
        this.renderFrame()
        animate()
      })
    }

    animate()
  }

  stop () {
    window.cancelAnimationFrame(this.nextFrame)
  }
}
